<template>
  <v-col :cols="attrs.cols">
    <!-- Parent item  -->
    <div class="naming">
      <ColControls
        :attrs="attrs"
        :editMode="editMode"
        :hideChildren="hideChildren"
        @delete="deleteList()"
        @update="applyNameChange()"
        @toggleEdit="editMode = !editMode"
        @toggleHide="hideChildren = !hideChildren"
      />

      <ColHeader
        v-if="editMode === false"
        :el="{ ...item, name: item.title }"
        :attrs="attrs"
        :depth-inc="1"
      />

      <div class="naming__header">
        <article
          v-if="!attrs.compact && editMode === false && attrs.note && item.body"
          class="mb-4"
        >
          <div class="pre-wrap" v-html="item.body"></div>
        </article>

        <div v-if="editMode === true">
          <ColForm
            :key="refItem.id"
            :new-item="refItem"
            :local="{ obj: attrs.listOne }"
            @update="updateList"
          />
        </div>

        <v-card v-if="cardForm" class="mb-4" elevation="2" outlined light>
          <v-card-text>
            <ItemForm
              :key="`${newItem.id}-${editKey}`"
              :new-item="newItem"
              :colors="colors"
              :local="{ obj: attrs.listOne }"
              :attrs="attrs"
              @submit="addItem"
              @cancel="cancel"
            />
          </v-card-text>
        </v-card>

        <div>
          <NestedDraggable
            :key="`nested-${item.id}`"
            :children="items"
            :attrs="attrs"
            :depth="0"
            :id="item.id"
            :local="{ obj: attrs.listOne }"
            :hide-children="hideChildren"
            :item="item"
            @deleteChildren="deleteChildren"
          />
        </div>

        <div
          v-if="!editMode && attrs.controls && attrs.add"
          class="d-flex justify-space-between mt-4"
        >
          <v-btn
            @click="addNewItem()"
            :color="cardForm ? 'grey' : 'amber'"
            class="mb-4"
            light
            rounded
            small
            >{{ cardForm ? "Close" : "+" }}</v-btn
          >
        </div>
      </div>
    </div>
  </v-col>
</template>

<script>
// @ is an alias to /src
import NestedDraggable from "@/views/user/exercises/logic-system/NestedDraggable";
import ItemForm from "@/views/user/exercises/logic-system/ItemForm";
import ColForm from "@/views/user/exercises/logic-system/ColForm";
import ColHeader from "@/views/user/exercises/logic-system/ColHeader";
import ColControls from "@/views/user/exercises/logic-system/ColControls";
import { checkPopulated } from "@/utils/types";

import { itemModel, initialState, colors } from "./model";

export default {
  name: "UserLogicCol",
  components: {
    NestedDraggable,
    ItemForm,
    ColForm,
    ColControls,
    ColHeader,
  },
  data() {
    return {
      items: this.value,
      refItem: this.item,
      newItem: { ...initialState },
      editMode: false,
      hideChildren: false,
      cardForm: false,
      editKey: 0,
      colors: colors,
    };
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: () => {},
    },
    attrs: {
      type: Object,
      deafult: () => {},
    },
  },
  watch: {
    value: {
      handler(val) {
        this.items = val;
      },
      deep: true,
    },
    items: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
    item: {
      handler(val) {
        // watch when a new item is passed from the parent and update our reference item
        this.refItem = val;
      },
      deep: true,
    },
    // refItem: {
    //   handler(val) {
    //     this.$emit("onEditList", val);
    //   },
    //   deep: true,
    // },
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    applyNameChange() {
      // this will emit the new refItem abck to the parent to ass in the updated item into this component
      this.$emit("onChangeName", {
        newTitle: this.refItem.title,
        ...this.refItem,
      });
      this.editMode = false;
    },
    deleteList() {
      this.$emit("onDeleteList", this.item);
    },
    deleteChildren($event) {
      this.$emit("deleteChildren", $event);
    },
    addNewItem() {
      // Object.assign(this.newItem, { ...itemModel });
      this.destroyProto();
      this.editKey++;
      this.$nextTick(() => {
        this.cardForm = !this.cardForm;
      });
    },
    addItem(ev) {
      // console.log("add item", ev);
      const item = this.constructItem({ ...itemModel }, ev);
      item.id = new Date().valueOf();
      this.items.push(item);
      this.cardForm = false;
      this.$emit("onEditList", ev);
    },
    destroyProto() {
      Object.assign(this.newItem, initialState());
      this.newItem.id = new Date().valueOf();
    },
    cancel() {
      this.cardForm = false;
    },
    constructItem(model, item) {
      const obj = {};
      Object.keys(model).forEach((key) => {
        obj[key] = checkPopulated(item[key]);
      });

      // console.log(item);

      return obj;
    },
    updateList(ev) {
      this.$emit("onEditList", ev);
      this.editMode = false;
    },
  },
};
</script>

<style lang="scss">
.delete {
  position: absolute !important;
  right: 0;
  top: 0;
  font-size: 1rem;
}
.naming {
  color: black;
}
</style>
